import { render, staticRenderFns } from "./PayFollowList.vue?vue&type=template&id=3cc830fe&scoped=true&"
import script from "./PayFollowList.vue?vue&type=script&lang=js&"
export * from "./PayFollowList.vue?vue&type=script&lang=js&"
import style0 from "./PayFollowList.vue?vue&type=style&index=0&id=3cc830fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc830fe",
  null
  
)

export default component.exports